import { ReactComponent as Reverse } from 'assets/icons/icon-reverse.svg';

export default Reverse;
